export function validatePhoneNumber(number: string): boolean {
  const regex = /^09\d{8}$/;
  return regex.test(number);
}
